import type { Firm } from '@domain/firm/model';

/// 弁護士詳細ヘッダー (`/lawyers/{id}`) の「所属」リンクに表示するラベルを解決する。
///
/// 保存値 `lawyers.firm_id` (UUID) は主表示にせず、表示ラベルとして
/// `firms.official_name` を使う (#571 / spec issue #569)。取得中・取得失敗でも
/// UUID を露出させず、状態を表す短い文言を返す。`assigneeDisplayName`
/// (detail-display.ts) と同じく「取得中」と「解決不能」を区別する。
///
/// DOM / store / Svelte に依存しない純粋関数。`firm_id` 自体の有無 (所属あり / なし)
/// は呼び出し側で判定する。この関数は「所属事務所はあるが名前ラベルをどう出すか」
/// だけを担うため、引数に `firm_id` を取らず、いかなる状態でも UUID を返し得ない。
///
/// - `firm` が解決済み (official_name あり) → 事務所名
/// - 取得中 → 「取得中…」
/// - 取得失敗 → 「事務所名を取得できません」
/// - 未開始 / 未解決 (loading でも error でもない) → 失敗と断定せず「取得中…」
export function affiliatedFirmLabel(
  firm: Pick<Firm, 'official_name'> | null | undefined,
  loading: boolean,
  hasError: boolean,
): string {
  const name = firm?.official_name?.trim();
  if (name) return name;
  if (loading) return '取得中…';
  if (hasError) return '事務所名を取得できません';
  // load 未開始の一瞬 (effect 実行前) は失敗と断定せず取得中扱いにし、
  // 誤って「取得できません」を出さない。
  return '取得中…';
}
